module.exports = __webpack_public_path__ + "img/logo-m2g-dark-no_url.b13b5fb3.png";